var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpOutlineThick = function SvgHelpOutlineThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-1.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11 7h2c1.65 0 3 1.35 3 3s-1.35 3-3 3v2h-2v-2c0-1.1.9-2 2-2 .55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8v-1c0-1.65 1.35-3 3-3",
    clipRule: "evenodd"
  })));
};
export { SvgHelpOutlineThick as Icon };
export default __webpack_public_path__ + "static/media/ad7c1e393f62a4b40461495d0391cae5.svg";